import { render, staticRenderFns } from "./SubstituicaoPrestadoresDownload.vue?vue&type=template&id=39838dde"
import script from "./SubstituicaoPrestadoresDownload.vue?vue&type=script&lang=js"
export * from "./SubstituicaoPrestadoresDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports